import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: { ...theme.containerGrid },
  totalContainer: {
    background: 'white',
    width: '265px',
    height: '65px',
    borderRadius: '34px',
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 1.5rem',
    margin: '2rem 0',
  },
  totalLabel: {
    //fontFamily: 'FuturaStdBook',
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
    fontSize: '30px',
    color: '#262957',
    // fontWeight: '300',
  },
  currency: {
    color: 'rgba(38, 41, 87, 0.3);',
    marginLeft: '20px',
  },
  inputButtonContainer: {
    textAlign: 'center',
  },
  inputButtonNumber: {
    width: '75px',
    height: '75px',
    backgroundColor: '#fff',
    borderRadius: '50%',
    margin: '.7rem auto',
    border: 'none',
    outline: 'none',
    '&:active': {
      background: theme.palette.secondary.main,
      color: '#fff',
    },
  },
  test: {
    color: '#868686',
    fontSize: '24px',
    fontWeight: 600,
    display: 'block',
  },
  ctaValidation: {
    textAlign: 'center',
  },
  ctaValidationButton: { width: '75px', height: '75px', margin: '.7rem 0' },
  ctaValidationLabel: {
    textTransform: 'capitalize',
  },
  disabled: {
    backgroundColor: '##e4e4e4',
    opacity: '.5',
  },
  hidePointerEvents: {
    pointerEvents: 'none',
  },

  /*   '@keyframes background': {
    '0%': {
      backgroundColor: '#fff',
      color: theme.palette.secondary.main,
    },
    '10%': {
      backgroundColor: theme.palette.secondary.main,
      color: '#fff',
    },
    '90%': {
      backgroundColor: theme.palette.secondary.main,
      color: '#fff',
    },
    '100%': {
      backgroundColor: '#fff',
      color: theme.palette.secondary.main,
    },
  }, */
}));

export default useStyles;
